import { MailFilled } from '@ant-design/icons';
import { Button, Skeleton, Table } from 'antd';
import ContactForSupport from '../components/ContactForSupport';
import { useState } from 'react';

interface props {
  columns?: any;
  loading?: boolean;
}

const DynamicTableSkeleton = ({ columns, loading }: props) => {
  const [isContactvailable, setIsContactvailable] = useState(false);
  const modifiedColumns = columns?.map((item: any) => {
    return {
      ...item,
      render: () => {
        return (
          <div style={{ paddingTop: '5px', paddingLeft: '10px' }}>
            <Skeleton active title={false} paragraph={{ rows: 1 }} />
          </div>
        );
      },
    };
  });
  const data = Array.from({ length: 10 }).map((_, i) => ({ key: i }));
  return (
    <div style={{ padding: '15px', transition: 'opacity 0.2s ease' }}>
      <Table
        size="small"
        bordered
        columns={modifiedColumns}
        dataSource={data}
        // pagination={scrollY ? false : pagination}
        pagination={false}
        footer={() => (
          <div
            style={{
              float: 'left',
              marginTop: '20px',
              background: 'none',
            }}
          >
            <Button
              type="link"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
              }}
              onClick={() => {
                setIsContactvailable(true);
              }}
            >
              <MailFilled />
              Contact for Support
            </Button>
            <ContactForSupport visible={isContactvailable} onClose={() => {}} />
          </div>
        )}
      />
    </div>
  );
};

export default DynamicTableSkeleton;
